import { ViewObjectSettings } from "../view-object-settings";

export class ColumnGridSettings extends ViewObjectSettings {
  constructor(settings) {
    super(settings);
    this.columnsSpace = settings.columnsSpace?.copy(); // type: CalculatedDimension
    this.columns = [];
    for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
      let columnSettings = settings.columns[columnIndex];
      let columnInfo = {
        width: columnSettings.width?.copy(), // type: CalculatedDimension
        rowsSpace: columnSettings.rowsSpace?.copy(), // type: CalculatedDimension
        rows: []
      };
      for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
        let rowSettings = columnSettings.rows[rowIndex];
        columnInfo.rows.push({
          height: rowSettings.height?.copy(),
          item: rowSettings.item?.copy() // type: ViewObjectSettings
        });
      }
      this.columns.push(columnInfo);
    }
  }

  copy() {
    return new ColumnGridSettings(this);
  }
}
